import React, { Component } from 'react';
import './FilterInput.css';
import FontIcon from '../../components/fontIcon/FontIcon';
import Label from '../../components/label/Label';
import models from '../../model/models';
import Input from '../input/Input';
import DateTime from 'react-datetime';
import Toggle from '../toggle/Toggle';
import Button from '../../components/button/Button';
import utils from '../../utils/utils';
import clone from 'lodash.clonedeep';
import toasts from '../../utils/toasts';

let defaultState = { showOptions: false, selectedOption: null, searchValue: null, datetime: null };

export default class FilterInput extends Component {
	constructor(props) {
		super(props);
		this.state = {
			showOptions: false,
			currentFilter: this.props.currentFilter
		};
	}

	componentDidMount = () => {
		document.body.addEventListener('click', this._backgroundClick, true);
	};

	componentWillUnmount = () => {
		document.body.removeEventListener('click', this._backgroundClick, true);
	};
	_setDateTimeValue = (datetime) => {
		datetime = new Date(datetime);
		this.setState({ datetime });
	};

	_backgroundClick = (e) => {
		if (this.node.contains(e.target)) return;
		this.setState(defaultState);
	};

	_addFilter = (value, name) => {
		let currentFilter = this.state.currentFilter || [];
		let selectedOption = this.props.options[this.state.selectedOption];
		currentFilter.push({ value, name, column: selectedOption.column, displayName: selectedOption.displayName });
		let state = clone(defaultState);
		state.currentFilter = currentFilter;

		this.setState(state, this._onChange);
	};

	_addDateFilter = () => {
		let currentFilter = this.state.currentFilter || [];
		let selectedOption = this.props.options[this.state.selectedOption];
		let datetime = this.state.datetime;
		if (!datetime) return toasts.show('pick a date');
		let toggleValue = this.toggle.getValue();
		let operator = toggleValue == 1 ? '>' : '<';
		let displayName = toggleValue == 1 ? 'Start' : 'End';
		currentFilter.push({
			value: { datetime, operator },
			name: utils.display_actual_datetime(datetime),
			column: selectedOption.column,
			displayName
		});
		let state = clone(defaultState);
		state.currentFilter = currentFilter;
		this.setState(state, this._onChange);
	};

	_filterOptions = (options, filterColumns) => {
		if (!this.state.searchValue) return options;
		filterColumns = filterColumns || ['name'];
		let finalOpt = [];
		for (let i in options) {
			for (let j in filterColumns) {
				let value = options[i][filterColumns[j]] || '';
				if (value.toLowerCase().indexOf(this.state.searchValue) !== -1) {
					finalOpt.push(options[i]);
					break;
				}
			}
		}
		return finalOpt;
	};

	getValue = () => {
		let currentFilter = this.state.currentFilter;
		let value = {};
		for (let i in currentFilter) {
			let column = currentFilter[i].column;
			if (!value[column]) value[column] = { values: [] };
			value[column].values.push(currentFilter[i].value);
		}
		return value;
	};

	_searchChange = (value) => {
		this.setState({ searchValue: value.toLowerCase() });
	};

	_toggleClick = () => {
		let state = clone(defaultState);
		state.showOptions = !this.state.showOptions;
		this.setState(state);
	};

	_removeFilter = (index) => {
		let currentFilter = this.state.currentFilter;
		currentFilter = currentFilter.splice(index, 1);
		this.setState(currentFilter, this._onChange);
	};

	_onChange = () => {
		let value = this.getValue();
		if (this.props.onChange) this.props.onChange(value);
	};

	_renderOptions = () => {
		if (!this.state.showOptions) return null;
		if (this.state.selectedOption) return null;
		let opt = [];
		for (let i in this.props.options) {
			opt.push(
				<Label
					tabIndex="0"
					className="initial-option"
					onClick={() => {
						this.setState({ selectedOption: i });
					}}
					key={i}
				>
					{this.props.options[i].displayName}
				</Label>
			);
		}
		return <div className="options-container">{opt}</div>;
	};

	_renderFinalOptions = () => {
		let selectedOption = this.props.options[this.state.selectedOption];
		if (!selectedOption) return;
		let options = null;
		if (selectedOption.model) {
			options = models[selectedOption.model].objs();
		} else if (selectedOption.options) {
			options = selectedOption.options;
		} else if (selectedOption.type === 'datetime') {
			return (
				<div className="final-options-container">
					<Toggle ref={(ref) => (this.toggle = ref)} option1="Start" option2="End" />
					<DateTime onChange={this._setDateTimeValue} />
					<Button bg="blue" color="white" onClick={this._addDateFilter}>
						Apply
					</Button>
				</div>
			);
		}
		options = this._filterOptions(options, selectedOption.filterColumns);
		let opts = [];
		for (let i in options) {
			opts.push(displayValues(options[i], selectedOption.filterColumns, this._addFilter));
		}
		return (
			<div className="final-options-container">
				<Input
					iconName="icon-search"
					placeholder={'Search ' + selectedOption.displayName + 's'}
					onChange={this._searchChange}
				/>
				{opts}
			</div>
		);
	};

	_renderCurrentFilters = () => {
		let curr = [];
		for (let i in this.state.currentFilter) {
			let current = this.state.currentFilter[i];
			if (!current) continue;
			curr.push(
				<Label
					tabIndex="0"
					className="current-filter"
					key={i}
					onClick={() => {
						this._removeFilter(i);
					}}
				>
					{' '}
					<Label className="remove">REMOVE</Label> <Label gray-medium>{current.displayName + ':'}</Label>
					<Label className="margin-left" black>
						{current.name}
					</Label>
				</Label>
			);
		}
		if (curr.length === 0)
			return (
				<Label className="current-filter message" key={9}>
					{' '}
					<FontIcon color="blue" name="icon-arrow-back" /> add a filter
				</Label>
			);
		return curr;
	};

	render() {
		return (
			<div className={'g-filter-input ' + (this.props.className || '')} ref={(ref) => (this.node = ref)}>
				<FontIcon tabIndex="0" name="icon-add" onClick={this._toggleClick} />
				{this._renderOptions()}
				{this._renderFinalOptions()}
				{this._renderCurrentFilters()}
			</div>
		);
	}
}

let displayValues = (object, displayFields, onClick) => {
	if (!object) return null;
	if (!displayFields) displayFields = ['name'];
	let names = [];
	for (let property of displayFields) {
		let propertyValue = object[property];
		if (property === 'barcode_id') {
			propertyValue = utils.upperCase(propertyValue);
		}
		names.push(propertyValue);
	}
	return (
		<div
			tabIndex="0"
			onClick={() => {
				onClick(object.id || object.value, names.join(' '));
			}}
			className="final-option"
			key={object.id}
		>
			{names.join(' ')}
		</div>
	);
};



// WEBPACK FOOTER //
// ./src/inputs/filterInput/FilterInput.jsx